import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useNavigate } from 'react-router-dom';
// import { MdAdd } from 'react-icons/md';
import { getCladdingWeight, getMainWeight } from './editor-components/weightSummary';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { setOriginalTower } from '../../modules/tower/towerWriteSlice';
import { removeTower } from '../../modules/tower/towerAPI';
import { listTower } from '../../modules/tower/towersSlice';
import ActionButtons from './ActionButtons';
import { formatDisplayValue } from './TowerEditor';

const TowerList = ({ loading, error, towers, project, user }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // 로딩중이거나 에러발생시
    if (loading || !towers) {
        return;
    }

    if (error) {
        return <TowerListBlock>에러가 발생했습니다</TowerListBlock>;
    }

    const onEdit = (tower) => {
        dispatch(setOriginalTower(tower));
        navigate('/write/tower');
    };

    const onRemove = async (id) => {
        
        try {
            await removeTower(id);
            dispatch(listTower(project._id));
        } catch (err) {
            console.error(err);
        }
    };

    const ownProject = (user && user._id) === (project && project.user._id);

    return (
        <TowerListBlock>
            <Helmet>
                <title>Tower List</title>
            </Helmet>
            <Content>
                <Caption>
                    <h1>Transfer Tower List</h1>
                </Caption>
                <Table id="table-to-xlsx">
                    <thead>
                        <tr>
                            <th rowSpan={2} style={{ minWidth: '70px' }}>Tower<br />ID.</th>
                            <th colSpan={4}>Size</th>
                            <th colSpan={3}>Floor Q'ty</th>
                            <th colSpan={3}>Floor Area (m2)</th>
                            <th colSpan={2}>Cladding Area (m2)</th>
                            <th colSpan={7}>Weight (kg)</th>
                            <th rowSpan={2}>Remarks</th>
                        </tr>
                        <tr>
                            {/* <th></th> */}
                            <th>Width</th>
                            <th>Length</th>
                            <th>Height</th>
                            <th>Volume</th>
                            <th>Drive</th>
                            <th>Non-Drive</th>
                            <th>Access</th>
                            <th>Drive</th>
                            <th>N.Drive</th>
                            <th>Access</th>
                            <th>Roofing</th>
                            <th>Siding</th>
                            <th>Structure</th>
                            <th>Cladding</th>
                            <th>Etc.</th>
                            <th>H.T.Bolt/Nut</th>
                            <th>Anchor Bolt</th>
                            <th>User Input</th>
                            <th>Total</th>
                            {/* <th></th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {towers &&
                            towers.map(
                                (tower) =>
                                    tower &&
                                    tower.body && (
                                        <tr key={tower._id}>
                                            <td>{tower.title}</td>
                                            <td>{formatDisplayValue(tower.body.size?.main?.width)}</td>
                                            <td>{formatDisplayValue(tower.body.size?.main?.length)}</td>
                                            <td>{formatDisplayValue(tower.body.size?.main?.height)}</td>
                                            <td>{formatDisplayValue(tower.body.size?.main?.volume)}</td>
                                            <td>{formatDisplayValue(tower.body.floors.driveFloor.qty)}</td>
                                            <td>{formatDisplayValue(tower.body.floors.nonDriveFloor.qty)}</td>
                                            <td>{formatDisplayValue(tower.body.floors.accessFloor.qty)}</td>
                                            <td>{formatDisplayValue(tower.body.floors.driveFloor.totalAreaFloor)}</td>
                                            <td>{formatDisplayValue(tower.body.floors.nonDriveFloor.totalAreaFloor)}</td>
                                            <td>{formatDisplayValue(tower.body.floors.accessFloor.totalAreaFloor)}</td>
                                            <td>{formatDisplayValue(tower.body.cladding.roofing.area)}</td>
                                            <td>{formatDisplayValue(tower.body.cladding.siding.area)}</td>
                                            <td>{formatDisplayValue(getMainWeight(tower.body.weightSummary))}</td>
                                            <td>{formatDisplayValue(getCladdingWeight(tower.body.weightSummary))}</td>
                                            <td>{formatDisplayValue(tower.body.etc?.etcWeight)}</td>
                                            <td>{formatDisplayValue(tower.body.etc?.fastenerWeight)}</td>
                                            <td>{formatDisplayValue(tower.body.etc?.anchorWeight)}</td>
                                            <td>{formatDisplayValue(tower.body.userInput?.weight)}</td>
                                            <td>{formatDisplayValue(tower.body.grandTotal)}</td>
                                            <td>
                                                {ownProject && <ActionButtons onEdit={() => onEdit(tower)} onRemove={() => onRemove(tower._id)} />}
                                            </td>
                                        </tr>
                                    ),
                            )}
                    </tbody>
                </Table>
            </Content>
        </TowerListBlock>
    );
};

export default TowerList;

const TowerListBlock = styled.div`
    display: flex;
`;

const Content = styled.div`
    width: 100%;
    overflow-x: auto;
`;

const Caption = styled.div`
    display: flex;
    justify-content: space-between;
    h1 {
        font-size: 1.125rem;
        margin: 0;
        margin-bottom: 1rem;
    }
`;

const Table = styled.table`
    //overflow-x: auto;   // 테이블을 감싸는 요소에 적용해야 한다.

    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
    text-align: center;
    thead tr th {
        font-weight: 500;
        padding: 0.5rem 0.25rem;
        background: ${palette.gray[2]};
        border-bottom: 2px solid ${palette.gray[4]};
    }
    tbody tr {
        &:nth-child(even) {
            background: ${palette.gray[2]};
        }
    }
    tbody tr td {
        height: 4rem;
        padding: 0.5rem 0.25rem;
    }
    .numeric {
        text-align: right;
    }
`;
